import "../CSS/itemUsuario.css";
import { storage } from "../FirebaseConfig/firebase";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";

import TextField from "@mui/material/TextField";
function ItemCupon(props) {
  const [sexo, setSexo] = useState("trabajador");
  const [asientos, setAsientos] = useState(props.asientos);
  const [estado, setEstado] = useState("#E1F4B2");

  useEffect(() => {
    if (props.estado == "Usado") setEstado("#FF8D8D");

  }, []);

  return (
    <div className="user-card">
      <div className="user-infocard">
        <img
          id="imagenTienda"
          className="user-icon"
          src={require(`../img/coupon.png`)}
          alt="flecha"
        />
        <div className="user-info">
          <div>
            <h5 className="user-nombre">{props.cip}</h5>
          </div>
          <Box sx={{ width: 120 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-end",
                marginLeft: "30px",
              }}
            >
             {asientos} Asiento(s)
            </Box>
          </Box>
        </div>

        <div className="user-state">
          <h5
            className="user-textState"
            style={{ backgroundColor: `${estado}` }}
          >
            {props.codigoCupon}
          </h5>
        </div>
        <img
          className="user-icon"
          src={require(`../img/borrar.png`)}
          alt="borrar"
          onClick={() => props.deleteCupon(props.idCupon)}
        />
      </div>
    </div>
  );
}

export default ItemCupon;
